import { Button } from "@chakra-ui/react";

// Custom button component with no border and no shadow
interface EditorButtonProps {
  isActive?: boolean;
  onClick: () => void;
  children: React.ReactNode;
  size?: "sm" | "md" | "lg";
  disabled?: boolean;
}

export function EditorButton({
  isActive = false,
  onClick,
  children,
  size = "sm",
  disabled = false,
}: EditorButtonProps) {
  return (
    <Button
      size={size}
      variant="ghost"
      bg={isActive ? "blue.100" : "transparent"}
      color={isActive ? "blue.600" : "gray.600"}
      _hover={{
        bg: isActive ? "blue.200" : "gray.100",
        color: isActive ? "blue.700" : "gray.700",
      }}
      _active={{
        bg: isActive ? "blue.300" : "gray.200",
      }}
      onClick={onClick}
      minW="auto"
      px={2}
      border="none"
      boxShadow="none"
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
